import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import Index from '../views/Index.vue'
import WorkOrder from '../views/WorkOrder.vue'
import Patrol from '../views/Patrol.vue'
import Contract from '../views/Contract.vue'
import GrainStore from '../views/GrainStore.vue'
import Warehouse from '../views/Warehouse.vue'
import Monitor from '../views/Monitor.vue'
import MonitorPlan from '../views/MonitorPlan.vue'
import Alarm from '../views/Alarm.vue'
import User from '../views/User.vue'
import Dept from '../views/Dept.vue'
import Menu from '../views/Menu.vue'
import Permission from '../views/Permission.vue'
import StoreRole from '../views/StoreRole.vue'
import Report from '../views/Report.vue'
import Integration from '../views/Integration.vue'
import System from '../views/System.vue'
import Log from '../views/Log.vue'
import Dashboard from '../views/Dashboard.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/index',
    children: [
      { path: 'index', name: 'Index', component: Index },
      { path: 'workorder', name: 'WorkOrder', component: WorkOrder },
      { path: 'patrol', name: 'Patrol', component: Patrol },
      { path: 'contract', name: 'Contract', component: Contract },
      { path: 'grain-store', name: 'GrainStore', component: GrainStore },
      { path: 'warehouse', name: 'Warehouse', component: Warehouse },
      { path: 'monitor', name: 'Monitor', component: Monitor },
      { path: 'monitor-plan', name: 'MonitorPlan', component: MonitorPlan },
      { path: 'alarm', name: 'Alarm', component: Alarm },
      { path: 'dept', name: 'Dept', component: Dept },
      { path: 'user', name: 'User', component: User },
      { path: 'menu', name: 'Menu', component: Menu },
      { path: 'permission', name: 'Permission', component: Permission },
      { path: 'store-role', name: 'StoreRole', component: StoreRole },
      { path: 'report', name: 'Report', component: Report },
      { path: 'integration', name: 'Integration', component: Integration },
      { path: 'system', name: 'System', component: System },
      { path: 'log', name: 'Log', component: Log }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    next()
  } else if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router